/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Input as AntdInput,
  Checkbox,
  Col,
  Layout,
  Radio,
  Row,
  Space,
  Card,
  Flex,
} from "antd";
import { Field, Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import Logo from "assets/images/logo_final_0.png";
import { Input, InputNumber, PhoneNumber, Select } from "components/form";
import { AuthBackground } from "components/layouts";

import schema, {
  FORM_STEP,
  REGISTER_DOCUMENT,
  REGISTER_TYPE,
  addressInitialValues,
  SignUpAddressSchema as addressSchema,
  singUpInitialValues,
} from "../schemas/signUpSchema";
import styles from "../styles/SignUp.module.css";
import { Content, Footer } from "antd/es/layout/layout";
import { Typography } from "antd/lib";
import Title from "antd/lib/typography/Title";
import { Button } from "components/elements";
import ModalTermCondition from "components/elements/Modal/ModalTermCondition";

const { Search } = AntdInput;

const SignUp = ({
  formStep = "",
  isLoading = false,
  companyTypeOptions = [],
  provinceOptions = [],
  districtOptions = [],
  subDistrictOptions = [],
  doSignUp = () => { },
  changeForm = () => { },
  onSubmitInfoForm = () => { },
  handleProviceChange = () => { },
  handleDistrictChange = () => { },
  getTaxConpanyOption = () => { },
  optionSearchTax = [],
  isModalOpen = false,
  showModal = () => { },
  handleCancel = () => { }
}) => {
  const { t } = useTranslation();

  console.log("optionSearchTax", optionSearchTax, companyTypeOptions);

  if (formStep === FORM_STEP.address) {
    return (

      <AuthBackground AuthBackground showLanguageSwitcher>
        <Layout>
          <Content style={{
            background: 'transparent',
            justifyContent: "center",
            textAlign: "left",
            minHeight: "93vh",
            display: "flex",
            alignItems: "center"
          }}>
            <Row justify={"center"} style={{
              marginLeft: "30vw",
              marginRight: "30vw",
              width: "553px"
            }}>
              <Card className={styles.formContainer}>
                <Formik
                  initialValues={addressInitialValues}
                  onSubmit={doSignUp}
                  validationSchema={addressSchema}
                >
                  {({ isValid, values, setFieldValue, setTouched }) => {
                    return (
                      <Form>
                        <p className={styles.header}>{t("signup.header")}</p>
                        <p className={styles.subHeader}>{t("signup.sub_header_address")}</p>
                        <Space style={{
                          width: "100%"
                        }} direction="vertical" >
                          <Row justify="left" style={{ marginTop: "10px", color: "#00275A" }}>
                            <h2>{t("signup.header_address_form")}</h2>
                          </Row>
                          <Flex gap={20} vertical={true}>
                            <Col span={24}>
                              <Input
                                name="address"
                                label={t("signup.input.address")}
                                placeholder={`${t("signup.input.address")} *`}
                                size="large"
                                required
                              />
                            </Col>
                            <Row>
                              <Col span={12} style={{ paddingRight: "12px" }}>
                                <Select
                                  name="province"
                                  label={t("signup.input.province")}
                                  placeholder={`${t("signup.input.province")} *`}
                                  size="large"
                                  options={provinceOptions}
                                  onChange={(val, item) => {
                                    console.log("itemm", item, val);
                                    handleProviceChange(item.provinceCode);
                                    setFieldValue("district", null);
                                    setFieldValue("subDistrict", null);
                                    setFieldValue("postalCode", null);
                                    setTouched(
                                      {
                                        district: false,
                                        subDistrict: false,
                                        postalCode: false,
                                      },
                                      false
                                    );
                                  }}
                                  required
                                />
                              </Col>
                              <Col span={12} style={{ paddingLeft: "12px" }}>
                                <Select
                                  name="district"
                                  label={t("signup.input.district")}
                                  placeholder={`${t("signup.input.district")} *`}
                                  size="large"
                                  options={districtOptions}
                                  onChange={(val, item) => {
                                    handleDistrictChange(item.districtCodeId);
                                    setFieldValue("subDistrict", null);
                                    setFieldValue("postalCode", null);
                                    setTouched(
                                      {
                                        subDistrict: false,
                                        postalCode: false,
                                      },
                                      false
                                    );
                                  }}
                                  required
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col span={12} style={{ paddingRight: "12px" }}>
                                <Select
                                  name="subDistrict"
                                  label={t("signup.input.subDistrict")}
                                  placeholder={`${t("signup.input.subDistrict")} *`}
                                  size="large"
                                  options={subDistrictOptions}
                                  onChange={(_, selectedValue) => {
                                    setFieldValue(
                                      "postalCode",
                                      selectedValue.zipCode || null
                                    );
                                    setTouched({ postalCode: false }, false);
                                  }}
                                  required
                                />
                              </Col>
                              <Col span={12} style={{ paddingLeft: "12px" }}>
                                <Input
                                  name="postalCode"
                                  label={t("signup.input.postalCode")}
                                  placeholder={`${t("signup.input.postalCode")} *`}
                                  size="large"
                                  maxLength={5}
                                  required
                                />
                              </Col>
                            </Row>

                            <Flex gap={10} vertical={true}>
                              <Col span={24}>
                                <Button
                                  className={styles.button}
                                  htmlType="submit"
                                  size="large"
                                  disabled={isLoading || !isValid}
                                >
                                  {t("signup.submitBtn")}
                                </Button>
                              </Col>

                              <Col span={24}>
                                <Button
                                  className={styles.button2}
                                  htmlType="button"
                                  type="default"
                                  size="large"
                                  onClick={() => {
                                    changeForm(FORM_STEP.info);
                                  }}
                                >
                                  {t("signup.backBtn")}
                                </Button>
                              </Col>
                            </Flex>
                          </Flex>
                        </Space>
                      </Form>
                    );
                  }}
                </Formik>
              </Card>
            </Row>
          </Content>
        </Layout>
      </AuthBackground>

    );
  }

  return (
    <AuthBackground AuthBackground showLanguageSwitcher>
      <Layout>
        <ModalTermCondition isModalOpen={isModalOpen} handleCancel={handleCancel} />
        <Content style={{
          background: 'transparent',
          justifyContent: "center",
          minHeight: "90vh",
          alignContent: "center"
          // textAlign: "center",
        }}>
          <Row style={{
            marginLeft: "30vw",
            marginRight: "30vw",

          }}>
            <Card className={styles.formContainer}>
              <Formik
                enableReinitialize
                initialValues={{ ...singUpInitialValues }}
                onSubmit={onSubmitInfoForm}
                validationSchema={schema}
              >
                {({ values, isValid, setFieldValue, setTouched }) => {
                  return (
                    <Form>
                      <p className={styles.header}>{t("signup.header")}</p>
                      <p className={styles.subHeader}>{t("signup.sub_header")}</p>
                      <Space style={{
                        width: "100%"
                      }} direction="vertical" size={15}>
                        <Row span={12} style={{ marginTop: "15px" }} >
                          <Field name="registerType">
                            {({ meta }) => (
                              <div>
                                <Radio.Group
                                  onChange={(e) => {
                                    setFieldValue("registerType", e.target.value);
                                    setTouched({}, false);
                                  }}
                                  value={values.registerType}
                                >
                                  <Radio value={REGISTER_TYPE.DOMESTIC}>
                                    {t("signup.input.thai")}
                                  </Radio>
                                  <Radio value={REGISTER_TYPE.OTHER}>
                                    {t("signup.input.other")}
                                  </Radio>
                                </Radio.Group>
                                {meta.touched && meta.error && (
                                  <div className="error">{meta.error}</div>
                                )}
                              </div>
                            )}
                          </Field>
                        </Row>

                        <Row>
                          {values.registerType === REGISTER_TYPE.DOMESTIC ? (
                            <>
                              <Col span={12} style={{ paddingRight: "12px" }}>
                                <Select
                                  // labelInValue={true}
                                  name="taxId"
                                  label={t("signup.input.companyName")}
                                  options={optionSearchTax}
                                  notFoundContent={true}
                                  filterOption={false}
                                  // open={values.taxId === undefined}
                                  onSearch={(val) => {
                                    // console.log("searchtext", val, val.length);
                                    if (val && val.length >= 3) {
                                      getTaxConpanyOption({ "searchtext": val })
                                      setFieldValue("taxId", undefined)
                                    }
                                  }}
                                  onChange={(val, _) => {
                                    console.log("onChange val", val, _?.fullNameTh, values.taxId);
                                    setFieldValue("companyName", _?.fullNameTh)
                                  }}
                                  placeholder={t("signup.input.companyName")}
                                  size="large"
                                />
                              </Col>

                              <Col span={12} style={{ paddingLeft: "12px" }}>
                                <Input
                                  disabled
                                  name="taxId"
                                  label={t("signup.input.taxId")}
                                  placeholder={t("signup.input.taxId")}
                                  size="large"
                                />
                              </Col>
                            </>
                          ) : (
                            <>
                              <Col span={24}>
                                <Input
                                  name="companyName"
                                  label={t("signup.input.companyName")}
                                  placeholder={`${t("signup.input.companyName")} *`}
                                  size="large"
                                  required
                                />
                              </Col>
                            </>
                          )}
                        </Row>
                        <Row>
                          <Col span={12} style={{ paddingRight: "12px" }}>
                            <Input
                              required={true}
                              name="name"
                              label={t("signup.input.name")}
                              placeholder={`${t("signup.input.name")} *`}
                              size="large"
                            />
                          </Col>
                          <Col span={12} style={{ paddingLeft: "12px" }}>
                            <Input
                              required={true}
                              name="surName"
                              label={t("signup.input.surName")}
                              placeholder={`${t("signup.input.surName")} *`}
                              size="large"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12} style={{ paddingRight: "12px" }}>
                            <Select
                              required={true}
                              name="businessType"
                              label={t("signup.input.businessType")}
                              placeholder={`${t("signup.input.your_businessType")} *`}
                              size="large"
                              options={companyTypeOptions}
                            />
                          </Col>
                          <Col span={12} style={{ paddingLeft: "12px" }}>
                            <InputNumber
                              required={true}
                              name="numberOfEmployees"
                              label={t("signup.input.numberOfEmployees")}
                              placeholder={`${t("signup.input.numberOfEmployees")} *`}
                              size="large"
                              min={1}
                              onStep={false}
                              controls={false}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12} style={{ paddingRight: "12px" }}>
                            <Input
                              required={true}
                              name="email"
                              label={t("signup.input.email")}
                              placeholder={`${t("signup.input.email")} *`}
                              size="large"
                            />
                          </Col>
                          <Col span={12} style={{ paddingLeft: "12px" }}>
                            <PhoneNumber
                              required={true}
                              name="phoneNo"
                              label={t("signup.input.phoneNo")}
                              placeholder={`${t("signup.input.phoneNo")} *`}
                              size="large"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Field name="idCardType">
                            {({ meta }) => (
                              <div>
                                <Radio.Group
                                  onChange={(e) => {
                                    const selectedType = e.target.value;
                                    setFieldValue("idCardType", selectedType);
                                    setFieldValue("idCardNumber", "");
                                    setTouched({}, false);
                                  }}
                                  value={values.idCardType}
                                >
                                  <Radio value={REGISTER_DOCUMENT.CITIZENID}>
                                    {t("signup.input.citizen_id")}
                                  </Radio>
                                  <Radio value={REGISTER_DOCUMENT.PASSPORT}>
                                    {t("signup.input.passport")}
                                  </Radio>
                                </Radio.Group>
                                {meta.touched && meta.error && (
                                  <div className="error">{meta.error}</div>
                                )}
                              </div>
                            )}
                          </Field>
                        </Row>
                        <Row>
                          <Col span={24}>
                            {values.idCardType === REGISTER_DOCUMENT.CITIZENID ? (
                              <Input
                                name="idCardNumber"
                                // label={t("signup.input.citizen_id")}
                                placeholder={`${t("signup.input.citizen_id")}`}
                                size="large"
                              />
                            ) : (
                              <Input
                                name="idCardNumber"
                                // label={t("signup.input.passport")}
                                placeholder={`${t("signup.input.passport")}`}
                                size="large"
                              />
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Field name="agreeTermsAndCond">
                            {({ field }) => (
                              <Checkbox
                                checked={field.value}
                                onChange={(e) => {
                                  setFieldValue("agreeTermsAndCond", e.target.checked);
                                }}
                              >
                                {t("signup.accept_tc")}{" "}
                                <a onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  showModal();
                                }}>{t("signup.tc")}</a>
                              </Checkbox>
                            )}
                          </Field>
                        </Row>
                        <Button
                          className={styles.button}
                          htmlType="submit"
                          size="large"
                          disabled={!isValid || !values.agreeTermsAndCond} // TODO: Waiting for API support.
                        // disabled={
                        //   !isValid ||
                        //   !values.agreeTermsAndCond ||
                        //   values.registerType === REGISTER_TYPE.DOMESTIC
                        // }
                        >
                          {t("signup.nextBtn")}
                        </Button>
                        <Row justify="center">
                          <p>
                            {t("signup.already_account")}{" "}
                            <a href="/login">{t("signup.signin")}</a>
                          </p>
                        </Row>
                      </Space>
                    </Form>
                  );
                }}
              </Formik>
            </Card>

          </Row>
        </Content>
        <Footer style={{ backgroundColor: "transparent" }}>
          <Flex vertical align="center">
            <span style={{ color: "#757575" }}>{t("common.version")} 1.3.4</span>
            <span style={{ color: "#757575" }}>
              Copyright (c) by Bright Expert Company Limited. All Rights Reserved.
            </span>
          </Flex>
        </Footer>
      </Layout>
    </AuthBackground>
  );
};

export default SignUp;
